import React from 'react';
import { RANGE_PRESETS, type RangePresetDays } from '../../utils/formatKpi';
import './TimeWindow.css';

interface TimeWindowProps {
  value: RangePresetDays;
  onChange: (days: RangePresetDays) => void;
}

export const TimeWindow: React.FC<TimeWindowProps> = ({ value, onChange }) => (
  <div className="time-window" role="group" aria-label="Time window">
    {RANGE_PRESETS.map((days) => (
      <button
        key={days}
        type="button"
        className={`time-window__btn${value === days ? ' time-window__btn--on' : ''}`}
        aria-pressed={value === days}
        onClick={() => onChange(days)}
      >
        {days} days
      </button>
    ))}
  </div>
);

export default TimeWindow;
